import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import bookingPerformance from "assets/images/icons/bookingPerformance.svg";
import Riyal from "assets/images/icons/darkRiyal.svg";
import completedBookings from "assets/images/icons/completedBookings.svg";
import totalCashback from "assets/images/icons/totalCashback.svg";
import occupancyRate from "assets/images/icons/occupancyRate.svg";
import cancelledBooking from "assets/images/icons/cancelledBooking.svg";
import cash from "assets/images/icons/cash.svg";
import riyalGray from "assets/images/icons/riyalGray.svg";
import info2 from "assets/images/icons/info2.svg";
import occupancyRateTooltip from "assets/images/occupancyRateTooltip.png";
import { BookingPerformanceIcon, DashboardOverViewCompletedBooklingsIcon, OccupancyRateIcon, TotalCashbackIcon } from "components/common/SVGIcons";

const BookingPerformance = () => {
  const { t } = useTranslation();
  const { overviewDashboard } = useSelector((state) => state.Dashboards);
  const [showTooltip, setShowTooltip] = useState(false);
  const { brandInfo } = useSelector((state) => state.auth);
  const { primaryColor } = brandInfo?.theme?.themeColors  || {};

  return (
    <Col lg={6}>
      <div className="inner_section">
        <div className="title_section">
          <BookingPerformanceIcon color={primaryColor}/>
          <h2 className="fs_20 text_black">{t("Booking Performance")}</h2>
        </div>
        <div className="sub_items">
          <div className="single_item">
            <TotalCashbackIcon color={primaryColor}/>
            <h2 className="fs_14 text_black mt-2">
              {t("Total Number of Bookings")}
            </h2>
            <div className="d-flex align-items-center gap-2 mt-4">
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.totalBookings?.toLocaleString(
                  "en-US"
                )}
              </h2>
            </div>
          </div>
          <div className="single_item">
            <OccupancyRateIcon color={primaryColor}/>
            <div className="g_between position-relative">
              <h2 className="fs_14 text_black mt-2">
                {t("Total Occupancy Rate")}
              </h2>
              <img
                src={info2}
                width={16}
                height={16}
                alt="info"
                className="c_p"
                onClick={() => setShowTooltip(!showTooltip)}
              />
              {showTooltip && (
                <img
                  src={occupancyRateTooltip}
                  width={650}
                  height={510}
                  alt="info"
                  className="c_p occupancy_tooltip_img"
                />
              )}
            </div>
            <div className="d-flex align-items-center gap-2 mt-4">
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.overallOccupancyRate?.toLocaleString(
                  "en-US"
                )}
                %
              </h2>
            </div>
            <p className="fs_10 text_dark_gray">
              {t("Expected revenue at 100% occupancy:")}
            </p>
            <p className="fs_12 text_dark_gray d-flex">
              <img
                src={Riyal}
                width={18}
                height={18}
                alt="riyal"
                className="px-1"
              />
              {overviewDashboard?.customers?.overallOccupancyRevenue?.toLocaleString(
                "en-US"
              )}
            </p>
          </div>
        </div>
        <div className="sub_items">
          <div className="single_item">
            <DashboardOverViewCompletedBooklingsIcon  width={24}
              height={24} color={primaryColor}/>
            <h2 className="fs_14 text_black mt-2">{t("Completed Bookings")}</h2>
            <div className="mt-4">
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.completedPercentage ?? 0}%
              </h2>
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.completedBookingCount?.toLocaleString(
                  "en-US"
                )}
              </h2>
            </div>
          </div>
          <div className="single_item">
            <img src={cancelledBooking} width={24} height={24} alt="cashback" />
            <h2 className="fs_14 text_black mt-2">{t("Cancelled Bookings")}</h2>
            <div className="mt-4">
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.cancelledPercentage ?? 0}%
              </h2>
              <div className="g_between">
                <h2 className="fs_24 text_black ">
                  {overviewDashboard?.customers?.cancelledBookingCount?.toLocaleString(
                    "en-US"
                  )}
                </h2>
                <div>
                  <h2 className="fs_12 text_dark_gray">
                    <img
                      src={cash}
                      width={15}
                      height={15}
                      alt="cash"
                      className="mx-1"
                    />
                    {t("Lost Value:")}
                  </h2>
                  <h2 className="fs_12 text_dark_gray text-end mt-1">
                    <img src={riyalGray} alt="riyal" width={10} height={11} />
                    {overviewDashboard?.customers?.cancelledBookingRevenue?.toLocaleString(
                      "en-US"
                    )}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default BookingPerformance;
